import React from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Event from '@ckeditor/ckeditor5-utils/src/eventinfo';
import {useOutsideEditorClick} from 'hooks';

export interface UseEditableFieldProps {
  defaultValue?: string | null;
  fallbackValue?: string;
  handleChange(value: string): void;
  initialEditing?: boolean;
}

export const useEditableField = ({defaultValue, fallbackValue, handleChange, initialEditing = false}: UseEditableFieldProps) => {
  const initialValue = defaultValue || '';
  const [editingValue, setEditingValue] = React.useState(initialValue);
  const [isEditing, setIsEditing] = React.useState(initialEditing);

  const setValues = (value: string) => {
    setEditingValue(value);
    handleChange(value);
  };

  const onChange = (_: Event, editor: ClassicEditor) => {
    const data = editor.getData();
    setValues(data);
  };

  const eventOnChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = (event) => setValues(event.target.value);

  const onBlur = () => {
    if (isEditing) {
      setIsEditing(false);

      if (editingValue.trim() === '' && fallbackValue) {
        setValues(fallbackValue);
      }
    }
  };

  const outsideClickRef = useOutsideEditorClick(onBlur);

  const enableEditing = () => setIsEditing(true);

  return {onBlur, onChange, eventOnChange, outsideClickRef, isEditing, value: editingValue, enableEditing};
};
